import emailjs from '@emailjs/browser';

const SERVICE_ID = 'service_mtw9a1f';
const TEMPLATE_ID = 'template_ukvfn1m';
const PUBLIC_KEY = 'qZ747ARg3GRyBAs1V';

const sendEmail = async (templateParams) => emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY);

export default sendEmail;
